Oskari.bundle_manager.registerDynamic('admin-layeranalytics', function() {return import(/* webpackChunkName: "chunk_admin-layeranalytics" */ 'oskari-loader!oskari-frontend/bundles/admin/admin-layeranalytics/bundle.js');});
